// Google map
// https://developers.google.com/maps/documentation/javascript/tutorial

let map;

function initHomeMap() {
    // set the bounds based on projects locations
    let bounds = new google.maps.LatLngBounds();

    //let projects = [
    //    { title: 'Damascus', coords: { lat: 33.5138, lng: 36.2765 } },
    //    { title: 'Aleppo', coords: { lat: 36.2021, lng: 37.1343 } },
    //    { title: 'Tartous', coords: { lat: 34.8959, lng: 35.8867 } },
    //    { title: 'Deir Ezzor', coords: { lat: 35.3297, lng: 40.1350 } }
    //];

    map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: 34.8021, lng: 38.9968 },
        zoom: 6
    });

    let info = new google.maps.InfoWindow();
    // https://developers.google.com/maps/documentation/javascript/infowindows

    projects.forEach(p => {

        let coords = p.coordinates.split(',');

        let marker = new google.maps.Marker({
            position: { lat: parseFloat(coords[0]), lng: parseFloat(coords[1]) },
            map: map,
            title: p.title,
            label: p.title.substr(0, 1)
            // https://developers.google.com/maps/documentation/javascript/examples/marker-labels
        });

        bounds.extend(marker.position);

        let content = '<h3 class="sans">' + '<a class="cyan" href="/Projects/Project/' + p.projectID + '">' + p.title + '</a>' + '</h3>' +
            '<small>' + (p.subTitle ? p.subTitle : '') + '</small>' +
            '<p class="light">' + (p.category ? p.category : '') + '</p>' +
            '<span>' + (p.location ? p.location : '') + '</span>';
            // '<p><a class="cyan" href="/Projects/Project/' + p.projectID + '">' + '&#128463; Project Page' + '</a></p>';

        marker.addListener('click', function () {
            info.setContent(content);
            info.open(map, marker);
        });
    });

    map.fitBounds(bounds);
}

function initMapForLocation() {

    let location = { lat: 34.8021, lng: 38.9968 };
    let zoom = 6;

    if (inCoords.value.length !== 0) {
        let inCoordsArray = inCoords.value.split(',');
        location = { lat: parseFloat(inCoordsArray[0]), lng: parseFloat(inCoordsArray[1]) };
        zoom = 14;
    }

    // https://developers.google.com/maps/documentation/javascript/basics
    map = new google.maps.Map(document.getElementById('map'), {
        center: location,
        zoom: zoom
        // mapTypeId: 'satellite'
    });

    if (inCoords.value.length !== 0) {
        setMarker(location);
    }

    map.addListener('rightclick', function (e) {

        if (marker !== null) {
            marker.setMap(null);
        }

        setMarker({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    });

    function setMarker(coords) {
        marker = new google.maps.Marker({
            position: coords,
            map: map,
            draggable: true,
            animation: google.maps.Animation.DROP,
            title: projectTitle
        });

        marker.addListener('drag', function (e) {
            updateCoords(marker.getPosition().lat() + ',' + marker.getPosition().lng());
        });

        updateCoords(coords.lat + ',' + coords.lng);
        saveButton.removeAttribute('disabled');
    }

    function updateCoords(coords) {
        inCoords.value = coords;
    }
}